<template>
  <transition name="collapse">
    <slot></slot>
  </transition>
</template>

<script>
/**
 * @class Collapse
 *
 * @description This component renders the collapsed view of a Panel
 */
export default {
  name: 'Collapse',
}
</script>

<style lang="scss">
.collapse-enter-active,
.collapse-leave-active {
  overflow: hidden;
  transition: max-height ease-in-out 0.2s;
  max-height: 500px;
}
.collapse-enter,
.collapse-leave-to {
  max-height: 0;
}
</style>
